import React from 'react';

import { SellerNotice } from '../components/SellerNotice';
import { useSellerNotice } from '../services/useSellerNotice';

export const SellerNoticeContainer: React.FC = () => {
  const sellerNoticeService = useSellerNotice();

  if (sellerNoticeService.isHide) {
    return null;
  }

  return <SellerNotice {...sellerNoticeService} />;
};
